/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon13IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon13Icon(props: Icon13IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
      className={classNames(
        "plasmic-default__svg",
        className,
        "w-5 h-5 min-w-5"
      )}
      viewBox={"0 0 24 24"}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M17 12.25h-.025c-.445 0-.816 0-1.12.02a2.822 2.822 0 00-.907.19 2.73 2.73 0 00-.198.09V11a5.25 5.25 0 012.1-4.2l1.6-1.2a.75.75 0 10-.9-1.2l-1.6 1.2a6.75 6.75 0 00-2.7 5.4v5.025c0 .445 0 .816.02 1.12.022.317.069.617.19.907a2.75 2.75 0 001.488 1.489c.29.12.59.167.907.188.304.021.675.021 1.12.021h.05c.445 0 .816 0 1.12-.02.317-.022.617-.069.907-.19a2.75 2.75 0 001.489-1.488c.12-.29.167-.59.188-.907.021-.304.021-.675.021-1.12v-.05c0-.445 0-.816-.02-1.12a2.822 2.822 0 00-.19-.907 2.75 2.75 0 00-1.488-1.489c-.29-.12-.59-.167-.907-.188-.304-.021-.675-.021-1.12-.021H17zm-1.478 1.595c.077-.032.194-.061.435-.078.247-.017.567-.017 1.043-.017s.796 0 1.043.017c.241.017.358.046.435.078.307.127.55.37.677.677.032.077.061.194.078.435.017.247.017.567.017 1.043s0 .796-.017 1.043c-.017.241-.046.358-.078.435a1.25 1.25 0 01-.677.677c-.077.032-.194.061-.435.078-.247.017-.567.017-1.043.017s-.796 0-1.043-.017c-.241-.017-.358-.046-.435-.078a1.25 1.25 0 01-.677-.677c-.032-.077-.061-.194-.078-.435A17.073 17.073 0 0114.75 16c0-.476 0-.796.017-1.043.017-.241.046-.358.078-.435.127-.307.37-.55.677-.677zM8.6 4.55a.75.75 0 01-.15 1.05l-1.6 1.2a5.25 5.25 0 00-2.1 4.2v1.55c.064-.032.13-.063.198-.09.29-.121.59-.168.907-.19.304-.02.675-.02 1.12-.02h.05c.445 0 .816 0 1.12.02.317.022.617.069.907.19a2.75 2.75 0 011.489 1.488c.12.29.167.59.188.907.021.304.021.675.021 1.12v.05c0 .445 0 .816-.02 1.12a2.822 2.822 0 01-.19.907 2.75 2.75 0 01-1.488 1.489c-.29.12-.59.167-.907.188-.304.021-.675.021-1.12.021h-.05c-.445 0-.816 0-1.12-.02a2.822 2.822 0 01-.907-.19 2.75 2.75 0 01-1.489-1.488c-.12-.29-.167-.59-.188-.907-.021-.304-.021-.675-.021-1.12V11c0-2.125 1-4.125 2.7-5.4l1.6-1.2a.75.75 0 011.05.15zm-3.078 9.295c.077-.032.194-.061.435-.078A17.07 17.07 0 017 13.75c.476 0 .796 0 1.043.017.241.017.358.046.435.078.307.127.55.37.677.677.032.077.061.194.078.435.017.247.017.567.017 1.043s0 .796-.017 1.043c-.017.241-.046.358-.078.435a1.25 1.25 0 01-.677.677c-.077.032-.194.061-.435.078A17.07 17.07 0 017 18.25c-.476 0-.796 0-1.043-.017-.241-.017-.358-.046-.435-.078a1.25 1.25 0 01-.677-.677c-.032-.077-.061-.194-.078-.435A17.091 17.091 0 014.75 16c0-.476 0-.796.017-1.043.017-.241.046-.358.078-.435.127-.307.37-.55.677-.677z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  );
}

export default Icon13Icon;
/* prettier-ignore-end */
